const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;
const GA_SCRIPT_TAG_ID = 'ga4-script-tag';

let isInitialized = false;

const canUseDOM = () => typeof window !== 'undefined' && typeof document !== 'undefined';

export const isAnalyticsEnabled = () => Boolean(GA_MEASUREMENT_ID);

export const initAnalytics = () => {
  if (!canUseDOM() || !isAnalyticsEnabled() || isInitialized) {
    return;
  }
  if (!document.getElementById(GA_SCRIPT_TAG_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_TAG_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  isInitialized = true;
};

export const trackPageView = (pagePath) => {
  if (!canUseDOM() || !isInitialized || !window.gtag) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (!canUseDOM() || !isInitialized || !window.gtag) {
    return;
  }
  window.gtag('event', eventName, eventParams);
};
